// extracted by mini-css-extract-plugin
module.exports = {"blogHeader":"blogPost_blogHeader__cCy2w","headerContainer":"blogPost_headerContainer___38WE","createdOn":"blogPost_createdOn__6af6F","appContainer":"blogPost_appContainer__qADRc"};